import React from "react";
import { Flex, Text } from "@chakra-ui/react";

interface Props {
  title: string;
  description?: string;
}

function CustomNoResults({ title, description }: Props) {
  return (
    <Flex
      flexDirection={"column"}
      alignItems={"center"}
      justifyContent={"center"}
      gap={"8px"}
      padding={"48px 16px"}
      borderRadius={"8px"}
      background={"#F7F9FA"}
    >
      <Text textStyle={"body-md-bold"} color={"#1D1D1B"}>
        {title}
      </Text>
      {description && (
        <Text textStyle={"body-sm-medium"} color={"#8F8F8C"}>
          {description}
        </Text>
      )}
    </Flex>
  );
}

export default CustomNoResults;
